/** Contexts — create view (delegates to the shared ContextForm). */
import { ContextForm } from "./_ContextForm";

export function ContextCreate() {
  return <ContextForm action="create" />;
}

export default ContextCreate;
